import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/one/project', { params }),
  getById: (id) => axios.get(`/api/v1/one/project/${id}`),
  generatePDF: ({ id, language }) => axios.get(`/api/v1/one/project/${id}/pdf/${language}`),
  create: (params) => axios.post('/api/v1/one/project', params),
  update: (params) => axios.put(`/api/v1/one/project/${params.id}`, params),
  delete: (params) => axios.delete('/api/v1/one/project', { params }),
};
